module.exports = __webpack_public_path__ + "img/not-found.6cd51d3b.svg";